<template>
    <div class="content">
        <img src="../../assets/img/sstz_bg.jpg" alt="">
    </div>
</template>

<script>
    export default {
        created () {
            document.title = "海科商户通上线啦";;
        },
    }
</script>

<style scoped>
.content img{
    width: 100%;
    display: block;
}
</style>